export default __webpack_public_path__ + "static/media/WheelMaintenance1.bc63d2fd.png";